<template>
  <div class="contact-section">
    <div class="row">
      <div class="col-sm-6 col-md-3 contact-column">
        <div class="contact-contain desk-address">
          <h3 :style="{color: headerColor}"><i class="fa fa-map-marker"></i> Get In Touch</h3>
          <a href="#">
            <address class="display-address">
              9999 Your Address<br />City, ST 11111
            </address>
          </a>
          <p>
            <strong>Sales: </strong>
            <a class="sales-phone">(123) 456-7891</a>
          </p>

          <p>
            <strong>Service: </strong>
            <a class="service-phone">(123) 456-7891</a>
          </p>
          <p>
            <strong>Parts: </strong>
            <a class="parts-phone">(123) 123-1234</a>
          </p>
        </div>
      </div>

      <div class="col-sm-6 col-md-3 contact-column">
        <div class="contact-contain sales-hours">
          <h3 :style="{color: headerColor}"><i class="fa fa-clock-o"></i> Sales Hours</h3>
          <p>
            <strong>Monday - Friday:</strong><br />
            <span class="sales-week-hours">9:00 AM - 8:00 PM</span>
          </p>
          <p>
            <strong>Saturday:</strong><br />
            <span class="sales-sat-hours">9:00 AM - 8:00 PM</span>
          </p>
          <p>
            <strong>Sunday:</strong><br />
            <span class="sales-sun-hours">Closed</span>
          </p>
        </div>
      </div>

      <div class="col-sm-6 col-md-3 contact-column">
        <div class="contact-contain service-hours">
          <h3 :style="{color: headerColor}"><i class="fa fa-clock-o"></i> Service Hours</h3>
          <p>
            <strong>Monday - Friday:</strong><br />
            <span class="service-week-hours">7:30 AM - 6:30 PM</span>
          </p>
          <p>
            <strong>Saturday:</strong><br />
            <span class="service-sat-hours">Closed</span>
          </p>
          <p>
            <strong>Sunday:</strong><br />
            <span class="service-sun-hours">Closed</span>
          </p>
        </div>
      </div>

      <!--parts hours column-->
      <div class="col-sm-6 col-md-3 contact-column">
        <div class="contact-contain parts-hours">
          <h3 :style="{color: headerColor}"><i class="fa fa-wrench"></i> Parts Hours</h3>
          <p>
            <strong>Monday - Friday:</strong><br />
            <span class="service-week-hours">7:30 AM - 5:30 PM</span>
          </p>
          <p>
            <strong>Saturday:</strong><br />
            <span class="service-sat-hours">8:00 AM - 1:00 PM</span>
          </p>
          <p>
            <strong>Sunday:</strong><br />
            <span class="service-sun-hours">Closed</span>
          </p>
        </div>
      </div>

      <!--parts hours column-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    ...mapGetters(["brandData"]),
    headerColor () {
      if (this.brand === 'none') {
        return '#cc0000';
      } else if (this.brand === 'toyota' || this.brand === 'nissan' || this.brand === 'mitsubishi' || this.brand === 'honda' || this.brand === 'chevrolet') {
        return 'var(--primary-color)';
      } else if (this.brand === 'cjdr') {
        return 'var(--secondary-color)';
      } else {
        return '#fff';
      }
    }
  },
  mounted() {
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.contact-section .desk-address a {
  color: #f5f5f5;
  cursor: pointer;
}
.contact-section .desk-address a:hover {
  text-decoration: underline !important;
}
.contact-section .col-sm-6.col-md-3 h3 {
  color: var(--primary-color);
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 600;
}
.contact-section {
  background-color: #161c20;
  margin: 0 auto;
  font-size: 16px;
  color: #f5f5f5;
  text-align: center;
  padding: 50px 15px;
}
.contact-section .contact-contain {
  display: table;
  margin: 0 auto;
}
.contact-section .contact-header {
  font-size: 1.2em;
}
.contact-section .contact-header {
  margin-top: 20px;
  margin-bottom: 10px;
}

@media (min-width: 768px) {
  .contact-column {
    min-height: 280px;
  }
}
@media (max-width: 991px) and (min-width: 768px) {
  .contact-column:nth-child(odd):after {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    content: " ";
    width: 1px;
    height: 80%;
    background-color: #d2d2d2;
  }
  .contact-column {
    border-bottom: 1px solid #d2d2d2;
  }
  .contact-column:last-child,
  .contact-column:nth-last-child(2) {
    border-bottom: none;
  }
}

@media (max-width: 767px) {
  .contact-section {
    padding: 0 15px;
  }
  .contact-column {
    padding-top: 10px;
    padding-bottom: 20px;
  }
  .contact-column:not(:last-child) {
    border-bottom: 1px solid #d2d2d2;
  }
}

@media (min-width: 992px) {
  .contact-column:not(:last-child) {
    border-right: 1px solid #d2d2d2;
  }
}
</style>
